export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  const $backendFetch = $fetch.create({
    baseURL: config.public.baseURL,

    onRequest({ options }) {
      const userStore = useUserStore()

      if (userStore.apiKey) {
        options.headers.set('Authorization', `Bearer ${userStore.apiKey}`)
      }

      options.headers.set('Accept', 'application/json')
      options.headers.set('Content-Type', 'application/json')
    },

    onResponseError({ response }) {
      const error: any = new Error(`Error: ${response.status} - ${response.statusText}`)
      error.status = response.status
      error.statusCode = response.status
      error.response = response
      throw error
    }
  })

  return {
    provide: {
      backendFetch: $backendFetch
    }
  }
})
